import { Component, inject, LOCALE_ID } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ScrollTopModule } from 'primeng/scrolltop';
import { FlagLanguagePipe, InfoLanguagePipe } from '@ls-commons/utils/pipes';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    ScrollTopModule,
    ButtonModule,
    RouterLink,
    FlagLanguagePipe,
    InfoLanguagePipe,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  hiddenTitle = true;
  hiddenLogo = true;

  locale = inject(LOCALE_ID);
}
